import { jsx as _jsx } from "react/jsx-runtime";
import { TranslatableString } from '@rjsf/utils';
import { ArrowUpIcon, ArrowDownIcon, CopyIcon, DeleteIcon } from '@chakra-ui/icons';
import ChakraIconButton from './ChakraIconButton';
export function CopyButton(props) {
    const { registry: { translateString }, } = props;
    return (_jsx(ChakraIconButton, { title: translateString(TranslatableString.CopyButton), ...props, icon: _jsx(CopyIcon, {}) }));
}
export function MoveDownButton(props) {
    const { registry: { translateString }, } = props;
    return (_jsx(ChakraIconButton, { title: translateString(TranslatableString.MoveDownButton), ...props, icon: _jsx(ArrowDownIcon, {}) }));
}
export function MoveUpButton(props) {
    const { registry: { translateString }, } = props;
    return (_jsx(ChakraIconButton, { title: translateString(TranslatableString.MoveUpButton), ...props, icon: _jsx(ArrowUpIcon, {}) }));
}
export function RemoveButton(props) {
    const { registry: { translateString }, } = props;
    return (_jsx(ChakraIconButton, { title: translateString(TranslatableString.RemoveButton), ...props, icon: _jsx(DeleteIcon, {}) }));
}
//# sourceMappingURL=IconButton.js.map